export default __webpack_public_path__ + "static/illustrationJoinUs-909047624a4ceb5686dfdca43cf719d7.svg";